import { render, staticRenderFns } from "./RootNodeConfig.vue?vue&type=template&id=0516bea4&scoped=true"
import script from "./RootNodeConfig.vue?vue&type=script&lang=js"
export * from "./RootNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./RootNodeConfig.vue?vue&type=style&index=0&id=0516bea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516bea4",
  null
  
)

export default component.exports